































































import Vue from 'vue';
import { CONTRACTS, FetchServiceContract } from '@/core/contracts';
import { ContextsState, SettingsState } from '@/store';
import { ResourceTypeTree } from '@/dto';
import { localize } from '@/core/filters';
import DxPopup from 'devextreme-vue/popup';
import DxButton from 'devextreme-vue/button';
import { Component } from 'vue-property-decorator';
import { TreeDropDown } from '@/core/components/controls';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
@Component({
    components: {
        DxPopup,
        DxButton,
        TreeDropDown,
    },
})
export default class FilterSelector extends Vue {
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    private visible: boolean = false;
    private resourceType: string = '';
    private productType: string = '';
    private resourceTypeFilterRef: string = 'resource-type-filter';
    private productTypeFilterRef: string = 'product-type-filter';

    private resourceTypeFilterInstance = this.$refs[
        this.resourceTypeFilterRef
    ] as TreeDropDown;
    private productTypeFilterInstance = this.$refs[
        this.productTypeFilterRef
    ] as TreeDropDown;

    public showPopUp() {
        this.visible = true;
    }

    private mounted() {
        this.resourceTypeFilterInstance = this.$refs[
            this.resourceTypeFilterRef
        ] as TreeDropDown;
        this.productTypeFilterInstance = this.$refs[
            this.productTypeFilterRef
        ] as TreeDropDown;
    }

    private onResourceTypeFilterSelected(filter: string) {
        this.resourceType = filter;
    }

    private onProductTypeFilterSelected(filter: string) {
        this.productType = filter;
    }

    private getLoadSelectedItemsHandler(): (items: any) => Promise<any[]> {
        return (items: any) => {
            return this.loadSelectedItems(items);
        };
    }

    private getLoadHandler(): (parameters: any) => Promise<any[]> {
        return (parameters: any) => {
            return this.load(parameters);
        };
    }

    private async load(parameters: any) {
        const currentContextId = ContextsState.currentContextId;
        let parentId = '';

        if (parameters) {
            if (parameters.parentId) {
                parentId = parameters!.parentId[0];
            } else {
                if (typeof parameters.filter[0] === 'object') {
                    parentId = parameters.filter[1][1];
                } else {
                    parentId = parameters.filter[1];
                }
            }
        }

        const url = `/contexts/${currentContextId}/resourceTypesList/${parentId}`;
        return await this._fetchService!.get<ResourceTypeTree[]>(url);
    }

    private async loadSelectedItems(items: any) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/contexts/${currentContextId}/resourceTypesList/selected/${items}`;
        const data = await this._fetchService!.get<ResourceTypeTree[]>(url);

        return data;
    }

    private get preselectedFilter() {
        const preselect =
            SettingsState.contextSettings.global.operationPlanFilter ?? '';

        if (preselect) {
            return JSON.parse(preselect);
        } else {
            return '';
        }
    }

    private get preselectResourceTypes() {
        return this.preselectedFilter?.resourceType?.join(',') ?? '';
    }

    private get localize() {
        return localize;
    }

    private saveOnClick() {
        this.$emit('onFilterSelected', this.makeFilter);
        this.visible = false;
    }

    private closeOnClick() {
        this.$emit('onFilterSelected', this.makeFilter);
        this.visible = false;
    }

    private clearOnClick() {
        this.resourceTypeFilterInstance.clearSelection();
        this.productTypeFilterInstance.clearSelection();

        this.$emit('onFilterSelected', this.makeFilter);
        this.visible = false;
    }

    private get makeFilter() {
        const filter: any = {};

        if (this.productType && this.productType) {
            filter.productType = this.productType;
        }

        if (this.resourceType && this.resourceType !== '') {
            filter.resourceType = this.resourceType;
        }

        return filter;
    }
}
